import { Provider } from '@angular/core'
import { GamePlayPollingService, GamePlayService } from 'game-play-services'
import { GamePlayConfig } from 'shared-services'
import { gamePlayConfigToken } from './game-play-config.token'

export const gamePlayPollingServiceProvider: Provider = {
  provide: GamePlayPollingService,
  useFactory: (
    gamePlayService: GamePlayService,
    gamePlayConfig: GamePlayConfig,
  ): GamePlayPollingService => {
    return new GamePlayPollingService(gamePlayService, gamePlayConfig)
  },
  deps: [GamePlayService, gamePlayConfigToken],
}
